import {
  faBagShopping,
  faCheck,
  faList,
  faRepeat,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  setDoc,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import {
  Accordion,
  Button,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  useAccordionButton,
} from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { useAuthContext } from "../../../hooks/useAuthContext";
import {
  addNotifyOrden,
  utilGetCollectionFilterReference,
  utilUpdateDocument,
} from "../../../util/UtilsFirebase";
import "./ViewPedido.css";
import { projectFirestore } from "../../../firebase/config";
import IngresoManual from "./IngresoManual";
import Ticket from "./Ticket";

const ViewPedidoNew = ({
  orden,
  show,
  handleClose,
  openTicket,
  cajaID,
  pagar,
}) => {
  const { employee, register } = useAuthContext();
  const [edicion, setEdicion] = useState(false);
  const [impresion, setImpresion] = useState(false);
  const [cobroExtra, setCobroExtra] = useState(false);
  const [localOrden, setLocalOrden] = useState(orden);
  const [items, setItems] = useState(orden.detalle);
  const [total, setTotal] = useState(orden.total);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(1);
  const [ticket, setTicket] = useState(false);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const [totalPages, setTotalPages] = useState();
  const [cobro, setCobro] = useState("0");
  const [cambio, setCambio] = useState("0");
  const [reembolso, setReembolso] = useState("");
  const [metodoPago, setMetodoPago] = useState("");
  const [puntosExtraM, setPuntosExtraM] = useState("");
  const [idPuntos, setIdPuntos] = useState("");
  const [puntosUser, setPuntosUser] = useState(0);

  const marcaPlatEntregar = async (newValue) => {
    let OTmp = localOrden;
    OTmp.recoger = false;
    let status = "";
    let msg = "";
    let notificacion = {};
    if (newValue.status === "ATENDIDO") {
      status = "ENTREGAR";
      msg = "¿Se marcara el platillo para ENTREGAR, desea continuar?";
      notificacion = {
        idv4: uuidv4(),
        turno_id: OTmp.id,
        user: OTmp.user,
        user_name: OTmp.user_name,
        status: "ENTREGAR",
        number: OTmp.number,
        puesto_name: OTmp.puesto_name,
        tipo_pago: OTmp.tipo_pago,
        description:
          "El platillo: " +
          newValue.name +
          " " +
          newValue.ncosto +
          " esta listo, favor de pasar a recogerlo.",
        active: true,
        pending: true,
        fecha: Timestamp.now(),
      };
    }
    if (window.confirm(msg)) {
      const updatedData = localOrden.detalle.map((item) =>
        item.idv4 === newValue.idv4 ? { ...item, status: status } : item,
      );
      OTmp.detalle = updatedData;
      await utilUpdateDocument("turnero", OTmp.id, OTmp);
      await addNotifyOrden(notificacion);
      setLocalOrden(OTmp);
    }
  };

  const handleCloseCobroExtra = (impr) => {
    if (localOrden.status === "PENDIENTE") {
      if (
        cobro >=
          total -
            parseFloat(localOrden.puntosusados) *
              parseFloat(
                localOrden.equivalenciapuntos
                  ? localOrden.equivalenciapuntos
                  : 0,
              ) ||
        metodoPago === "Tarjeta"
      ) {
        if (impr) {
          marcaOrdenAntendida(true);
        } else {
          marcaOrdenAntendida();
        }
      } else {
        alert("el cobro debe ser mayor o igual al total");
      }
    } else {
      if (cobro >= reembolso || metodoPago === "Tarjeta") {
        if (impr) {
          update(true);
        } else {
          update();
        }
      } else {
        alert("el cobro debe ser mayor o igual al faltante");
      }
    }
  };

  const handleEfectivo = (cantidad) => {
    if (localOrden.status === "PENDIENTE") {
      let Cambio =
        parseFloat(total) -
        parseFloat(cantidad) -
        parseFloat(localOrden.puntosusados) *
          parseFloat(
            localOrden.equivalenciapuntos ? localOrden.equivalenciapuntos : 0,
          );
      setCambio(-Cambio.toFixed(2));
      setCobro(cantidad);
    } else {
      let Cambio = parseFloat(reembolso) + parseFloat(cantidad);
      setCambio(Cambio.toFixed(2));
      setCobro(cantidad);
    }
  };

  const handleRemove = (index) => {
    if (
      window.confirm("Se eliminara el platillo de la orden, ¿desea continuar?")
    ) {
      const newArray = items.filter((item, i) => item !== index);
      if (newArray.length === 0) {
        marcaOrdenCancelada();
      } else {
        let total = 0;
        let puntos = 0;
        newArray.forEach((element) => {
          total += element.costo * element.cantidad;
          puntos += parseFloat(element.npuntos) * element.cantidad;
          total += element.totalAnadidos;
        });
        setPuntosExtraM(puntos);
        if (localOrden.status === "ATENDIDO") {
          setReembolso(localOrden.total - total);
        }
        setTotal(total);
        setItems(newArray);
        setCurrentPage(1);
      }
    }
  };

  const ChangeMetPag = (e) => {
    if (e.target.value === "Efectivo") {
      let DivEfect = document.getElementById("divEfect");
      DivEfect.removeAttribute("hidden");
    } else {
      let DivEfect = document.getElementById("divEfect");
      DivEfect.hidden = true;
    }
    setMetodoPago(e.target.value);
  };

  const handleCloseEdicion = (orden) => {
    setLocalOrden(orden);
    console.log(orden);
    setEdicion(false);
  };

  const update = async (item) => {
    if (employee !== undefined) {
      localOrden.atendio = employee.id_usuario;
    } else {
      localOrden.atendio = "Administrador";
    }
    if (reembolso < 0) {
      if (metodoPago === "Tarjeta") {
        localOrden.cobro = parseFloat(localOrden.cobro) - parseFloat(reembolso);
      } else {
        localOrden.cobro = parseFloat(localOrden.cobro) + parseFloat(cobro);
        localOrden.cambio = parseFloat(localOrden.cambio) + parseFloat(cambio);
      }
    } else {
      localOrden.cambio = parseFloat(localOrden.cambio) + parseFloat(reembolso);
    }
    localOrden.detalle = items;
    localOrden.total = total;
    localOrden.puntosgenerados = puntosExtraM;
    localOrden.cobroiva = total - total / (1 + orden.iva / 100);
    let OTmp = localOrden;
    OTmp.recoger = false;
    let status = localOrden.status;
    let msg = "Las modificaciones no se podran revertir, ¿Desea continuar?";
    let notificacion = {
      idv4: uuidv4(),
      turno_id: OTmp.id,
      user: OTmp.user,
      user_name: OTmp.user_name,
      status: OTmp.status,
      number: OTmp.number,
      puesto_name: OTmp.puesto_name,
      tipo_pago: OTmp.tipo_pago,
      description:
        "Su orden con numero: " + OTmp.number + ", ha sido modificada.",
      active: true,
      pending: true,
      fecha: Timestamp.now(),
    };
    if (window.confirm(msg)) {
      const updatedData = localOrden.detalle.map((item) => ({
        ...item,
        status: status,
      }));
      OTmp.detalle = updatedData;
      OTmp.status = status;
      OTmp.caja = cajaID;
      await utilUpdateDocument("turnero", OTmp.id, OTmp);
      await addNotifyOrden(notificacion);
      setLocalOrden(OTmp);
      if (item) {
        setImpresion(true);
      }
      handleClose();
    }
  };

  const marcaPlatAntendido = async (newValue) => {
    let OTmp = localOrden;
    OTmp.recoger = false;
    let status = "";
    let msg = "";
    let notificacion = {};
    if (newValue.status === "PENDIENTE") {
      status = "ATENDIDO";
      msg = "¿Se marcara el platillo como atendido, desea continuar?";
      notificacion = {
        idv4: uuidv4(),
        turno_id: OTmp.id,
        user: OTmp.user,
        user_name: OTmp.user_name,
        status: "ATENDIDO",
        number: OTmp.number,
        puesto_name: OTmp.puesto_name,
        tipo_pago: OTmp.tipo_pago,
        description:
          "El platillo: " +
          newValue.name +
          " " +
          newValue.ncosto +
          " se esta preparando, espere para recoger.",
        active: true,
        pending: true,
        fecha: Timestamp.now(),
      };
    }
    if (newValue.status === "ATENDIDO") {
      status = "ENTREGAR";
      msg = "¿Se marcara el platillo para ENTREGAR, desea continuar?";
      notificacion = {
        idv4: uuidv4(),
        turno_id: OTmp.id,
        user: OTmp.user,
        user_name: OTmp.user_name,
        status: "ENTREGAR",
        number: OTmp.number,
        puesto_name: OTmp.puesto_name,
        tipo_pago: OTmp.tipo_pago,
        description:
          "El platillo: " +
          newValue.name +
          " " +
          newValue.ncosto +
          " esta listo, favor de pasar a recogerlo.",
        active: true,
        pending: true,
        fecha: Timestamp.now(),
      };
    }
    if (newValue.status === "COMPLETADO") {
      status = "PENDIENTE";
      msg = "¿Se marcara el platillo como pendiente, desea continuar?";
      notificacion = {
        idv4: uuidv4(),
        turno_id: OTmp.id,
        user: OTmp.user,
        user_name: OTmp.user_name,
        status: "PENDIENTE",
        number: OTmp.number,
        puesto_name: OTmp.puesto_name,
        tipo_pago: OTmp.tipo_pago,
        description:
          "El platillo: " +
          newValue.name +
          " " +
          newValue.ncosto +
          " aun se esta preparando, gracias por la espera.",
        active: true,
        pending: true,
        fecha: Timestamp.now(),
      };
    }
    if (window.confirm(msg)) {
      const updatedData = localOrden.detalle.map((item) =>
        item.idv4 === newValue.idv4 ? { ...item, status: status } : item,
      );
      OTmp.detalle = updatedData;
      await utilUpdateDocument("turnero", OTmp.id, OTmp);
      await addNotifyOrden(notificacion);
      setLocalOrden(OTmp);
    }
  };

  const marcaOrdenAntendida = async (impres) => {
    if (employee !== undefined) {
      localOrden.atendio = employee.id_usuario;
    } else {
      localOrden.atendio = "Administrador";
    }
    if (metodoPago === "Tarjeta") {
      localOrden.cobro =
        total -
        parseFloat(localOrden.puntosusados) *
          parseFloat(
            localOrden.equivalenciapuntos ? localOrden.equivalenciapuntos : 0,
          );
      localOrden.cambio = 0;
    } else {
      localOrden.cobro = cobro;
      localOrden.cambio = cambio;
    }
    if (parseFloat(puntosExtraM) > 0) {
      localOrden.puntosgenerados = puntosExtraM;
    }
    localOrden.total = total;
    localOrden.caja = cajaID;
    localOrden.tipo_pago = metodoPago;
    localOrden.cobroiva = total - total / (1 + orden.iva / 100);
    let OTmp = localOrden;
    OTmp.recoger = false;
    let status = "ATENDIDO";
    let msg = "¿Se marcara la orden como pagada, desea continuar?";
    let notificacion = {
      idv4: uuidv4(),
      turno_id: OTmp.id,
      user: OTmp.user,
      user_name: OTmp.user_name,
      status: "ATENDIDO",
      number: OTmp.number,
      puesto_name: OTmp.puesto_name,
      tipo_pago: OTmp.tipo_pago,
      description: "Su orden con numero: " + OTmp.number + ", esta pagada.",
      active: true,
      pending: true,
      fecha: Timestamp.now(),
    };
    if (window.confirm(msg)) {
      const updatedData = localOrden.detalle.map((item) => ({
        ...item,
        status: status,
      }));
      OTmp.detalle = updatedData;
      OTmp.status = status;
      let puntosModificar = puntosUser;
      if (parseFloat(localOrden.puntosusados) > 0 && idPuntos) {
        addDoc(collection(projectFirestore, "puntos", idPuntos, "historial"), {
          descripcion: "Se usaron " + localOrden.puntosusados + " puntos",
          fecha: new Date(),
          folioOrden: localOrden.folio ? localOrden.folio : "0",
        });
        setDoc(doc(projectFirestore, "puntos", idPuntos), {
          id_usuario: localOrden.user,
          id_local: localOrden.puesto,
          puntos: puntosUser - parseFloat(localOrden.puntosusados),
        });
        puntosModificar = puntosUser - parseFloat(localOrden.puntosusados);
      }
      if (
        parseFloat(localOrden.puntosgenerados) > 0 &&
        idPuntos &&
        !localOrden.reclamados
      ) {
        OTmp.reclamados = true;
        addDoc(collection(projectFirestore, "puntos", idPuntos, "historial"), {
          descripcion: "Obtuviste " + localOrden.puntosgenerados + " puntos",
          fecha: new Date(),
          folioOrden: localOrden.folio ? localOrden.folio : "0",
        });
        setDoc(doc(projectFirestore, "puntos", idPuntos), {
          id_usuario: localOrden.user,
          id_local: localOrden.puesto,
          puntos: puntosModificar + parseFloat(localOrden.puntosgenerados),
        });
      }
      localOrden.detalle.forEach(async (itemdet) => {
        const menuH = await utilGetCollectionFilterReference(
          "menu",
          "registro",
          "==",
          register.id,
          "registro",
        );
        if (itemdet?.id && itemdet?.selectedDate && itemdet?.selectedTime) {
          const documplat = doc(
            projectFirestore,
            "menu",
            menuH[0].id,
            "platillo",
            itemdet.id,
          );
          if (itemdet?.selectedDate && itemdet?.selectedTime) {
            const dataplat = (await getDoc(documplat)).data();
            let dispo3 = { ...dataplat?.reservados };
            if (
              dispo3 &&
              dispo3[itemdet?.selectedDate] &&
              dispo3[itemdet?.selectedDate][itemdet?.selectedTime]
            ) {
              dispo3[itemdet?.selectedDate][itemdet?.selectedTime] =
                dispo3[itemdet?.selectedDate][itemdet?.selectedTime] -
                itemdet?.cantidad;
            }
            let dispo2 = { ...dataplat?.fechas };
            if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              dispo2[itemdet?.selectedDate][itemdet?.selectedTime]
            ) {
              dispo2[itemdet?.selectedDate][itemdet?.selectedTime] =
                dispo2[itemdet?.selectedDate][itemdet?.selectedTime] +
                itemdet?.cantidad;
            } else if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              !dispo2[itemdet?.selectedDate][itemdet?.selectedTime]
            ) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  ...dispo2[itemdet?.selectedDate],
                  [itemdet?.selectedTime]: itemdet?.cantidad,
                },
              };
            } else if (dispo2 && !dispo2[itemdet?.selectedDate]) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedTime]: itemdet?.cantidad,
                },
              };
            } else {
              dispo2 = {
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedTime]: itemdet?.cantidad,
                },
              };
            }
            updateDoc(documplat, { fechas: dispo2, reservados: dispo3 });
          } else {
            const dataplat = (await getDoc(documplat)).data();
            let dispo3 = { ...dataplat?.reservados };
            if (
              dispo3 &&
              dispo3[itemdet?.selectedDate] &&
              dispo3[itemdet?.selectedDate][itemdet?.selectedDate]
            ) {
              dispo3[itemdet?.selectedDate][itemdet?.selectedDate] =
                dispo3[itemdet?.selectedDate][itemdet?.selectedDate] -
                itemdet?.cantidad;
            }
            let dispo2 = { ...dataplat?.fechas };
            if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              dispo2[itemdet?.selectedDate][itemdet?.selectedDate]
            ) {
              dispo2[itemdet?.selectedDate][itemdet?.selectedDate] =
                dispo2[itemdet?.selectedDate][itemdet?.selectedDate] +
                itemdet?.cantidad;
            } else if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              !dispo2[itemdet?.selectedDate][itemdet?.selectedDate]
            ) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  ...dispo2[itemdet?.selectedDate],
                  [itemdet?.selectedDate]: itemdet?.cantidad,
                },
              };
            } else if (dispo2 && !dispo2[itemdet?.selectedDate]) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedDate]: itemdet?.cantidad,
                },
              };
            } else {
              dispo2 = {
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedDate]: itemdet?.cantidad,
                },
              };
            }
            updateDoc(documplat, { fechas: dispo2, reservados: dispo3 });
          }
        }
      });
      await utilUpdateDocument("turnero", OTmp.id, OTmp);
      await addNotifyOrden(notificacion);
      setLocalOrden(OTmp);
      if (impres) {
        setImpresion(true);
      } else {
        handleClose();
      }
    }
  };

  const marcaOrdenEntregar = async () => {
    let OTmp = localOrden;
    OTmp.recoger = false;
    let status = "ENTREGAR";
    let msg = "¿Se marcara la orden para ENTREGAR, desea continuar?";
    let notificacion = {
      idv4: uuidv4(),
      turno_id: OTmp.id,
      user: OTmp.user,
      user_name: OTmp.user_name,
      status: "ENTREGAR",
      number: OTmp.number,
      puesto_name: OTmp.puesto_name,
      tipo_pago: OTmp.tipo_pago,
      description:
        "Su orden con numero: " +
        OTmp.number +
        ", esta lista, favor de pasar a recogerla.",
      active: true,
      pending: true,
      fecha: Timestamp.now(),
    };
    if (window.confirm(msg)) {
      OTmp.status = status;
      await utilUpdateDocument("turnero", OTmp.id, OTmp);
      await addNotifyOrden(notificacion);
      setLocalOrden(OTmp);
      handleClose();
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp.seconds * 1000);
    const formattedDate = date.toLocaleDateString("en-GB");
    const formattedTime = date.toLocaleTimeString("en-US");
    return {
      date: formattedDate,
      time: formattedTime,
    };
  };

  const marcaOrdenEntregarMesa = async () => {
    let OTmp = localOrden;
    OTmp.recoger = false;
    let status = "ENTREGAR";
    let msg = "¿Se marcara la orden para ENTREGAR, desea continuar?";
    let notificacion = {
      idv4: uuidv4(),
      turno_id: OTmp.id,
      user: OTmp.user,
      user_name: OTmp.user_name,
      status: "ENTREGAR",
      number: OTmp.number,
      puesto_name: OTmp.puesto_name,
      tipo_pago: OTmp.tipo_pago,
      description:
        "Su orden con numero: " +
        OTmp.number +
        ", esta lista y va en camino con usted, favor de permanecer en la mesa #" +
        OTmp.table +
        ".",
      active: true,
      pending: true,
      fecha: Timestamp.now(),
    };
    if (window.confirm(msg)) {
      OTmp.status = status;
      await utilUpdateDocument("turnero", OTmp.id, OTmp);
      await addNotifyOrden(notificacion);
      setLocalOrden(OTmp);
      handleClose();
    }
  };

  const marcaOrdenCompleta = async () => {
    let OTmp = localOrden;
    OTmp.recoger = false;
    let status = "COMPLETADO";
    let msg = "¿Se marcara la orden como completada, desea continuar?";
    let notificacion = {
      idv4: uuidv4(),
      turno_id: OTmp.id,
      user: OTmp.user,
      user_name: OTmp.user_name,
      status: "COMPLETADO",
      number: OTmp.number,
      puesto_name: OTmp.puesto_name,
      tipo_pago: OTmp.tipo_pago,
      description: "Su orden con numero: " + OTmp.number + ", esta completa.",
      active: true,
      pending: true,
      fecha: Timestamp.now(),
    };
    if (window.confirm(msg)) {
      OTmp.status = status;
      await utilUpdateDocument("turnero", OTmp.id, OTmp);
      await addNotifyOrden(notificacion);
      setLocalOrden(OTmp);
      handleClose();
    }
  };

  const marcaOrdenPendiente = async () => {
    localOrden.detalle.forEach((element) => {
      element.status = "PENDIENTE";
    });
    let OTmp = localOrden;
    let status = "PENDIENTE";
    let msg = "¿Se marcara la orden como pendiente, desea continuar?";
    let notificacion = {
      idv4: uuidv4(),
      turno_id: OTmp.id,
      user: OTmp.user,
      user_name: OTmp.user_name,
      status: "PENDIENTE",
      number: OTmp.number,
      puesto_name: OTmp.puesto_name,
      tipo_pago: OTmp.tipo_pago,
      description:
        "Su orden con numero: " +
        OTmp.number +
        ", se esta atendiendo. Gracias por su paciencia.",
      active: true,
      pending: true,
      fecha: Timestamp.now(),
    };
    if (window.confirm(msg)) {
      OTmp.status = status;
      let puntosModificar = puntosUser;
      if (parseFloat(localOrden.puntosusados) > 0 && idPuntos) {
        addDoc(collection(projectFirestore, "puntos", idPuntos, "historial"), {
          descripcion: "Se regresaron " + localOrden.puntosusados + " puntos",
          fecha: new Date(),
          folioOrden: localOrden.folio ? localOrden.folio : "0",
        });
        setDoc(doc(projectFirestore, "puntos", idPuntos), {
          id_usuario: localOrden.user,
          id_local: localOrden.puesto,
          puntos: puntosUser + parseFloat(localOrden.puntosusados),
        });
        puntosModificar = puntosUser + parseFloat(localOrden.puntosusados);
      }
      if (
        parseFloat(localOrden.puntosgenerados) > 0 &&
        idPuntos &&
        localOrden.reclamados
      ) {
        OTmp.reclamados = false;
        addDoc(collection(projectFirestore, "puntos", idPuntos, "historial"), {
          descripcion:
            "Se cancelaron " + localOrden.puntosgenerados + " puntos",
          fecha: new Date(),
          folioOrden: localOrden.folio ? localOrden.folio : "0",
        });
        setDoc(doc(projectFirestore, "puntos", idPuntos), {
          id_usuario: localOrden.user,
          id_local: localOrden.puesto,
          puntos: puntosModificar - parseFloat(localOrden.puntosgenerados),
        });
      }
      await utilUpdateDocument("turnero", OTmp.id, OTmp);
      await addNotifyOrden(notificacion);
      setLocalOrden(OTmp);
      handleClose();
    }
  };

  const marcaOrdenCancelada = async () => {
    let OTmp = localOrden;
    OTmp.recoger = false;
    let status = "CANCELADO";
    let msg = "¿La orden sera cancelada, desea continuar?";
    let notificacion = {
      active: true,
      description: "Su orden con numero: " + OTmp.number + ", se ha cancelado.",
      fecha: Timestamp.now(),
      idv4: uuidv4(),
      status: "CANCELADO",
      turno_id: OTmp.id,
      user_name: OTmp.user_name,
      number: OTmp.number,
      puesto_name: OTmp.puesto_name,
      tipo_pago: OTmp.tipo_pago,
      pending: true,
      user: OTmp.user,
    };

    if (window.confirm(msg)) {
      if (localOrden.status !== "PENDIENTE") {
        localOrden.detalle.forEach(async (itemdet) => {
          const menuH = await utilGetCollectionFilterReference(
            "menu",
            "registro",
            "==",
            register.id,
            "registro",
          );
          if (itemdet?.id && itemdet?.selectedDate && itemdet?.selectedTime) {
            const documplat = doc(
              projectFirestore,
              "menu",
              menuH[0].id,
              "platillo",
              itemdet.id,
            );
            if (itemdet?.selectedDate && itemdet?.selectedTime) {
              const dataplat = (await getDoc(documplat)).data();
              let dispo2 = { ...dataplat?.fechas };
              if (
                dispo2 &&
                dispo2[itemdet?.selectedDate] &&
                dispo2[itemdet?.selectedDate][itemdet?.selectedTime]
              ) {
                dispo2[itemdet?.selectedDate][itemdet?.selectedTime] =
                  dispo2[itemdet?.selectedDate][itemdet?.selectedTime] -
                  itemdet?.cantidad;
                updateDoc(documplat, { fechas: dispo2 });
              }
            } else {
              const dataplat = (await getDoc(documplat)).data();
              let dispo2 = { ...dataplat?.fechas };
              if (
                dispo2 &&
                dispo2[itemdet?.selectedDate] &&
                dispo2[itemdet?.selectedDate][itemdet?.selectedDate]
              ) {
                dispo2[itemdet?.selectedDate][itemdet?.selectedDate] =
                  dispo2[itemdet?.selectedDate][itemdet?.selectedDate] -
                  itemdet?.cantidad;
                updateDoc(documplat, { fechas: dispo2 });
              }
            }
          }
        });
      } else {
        localOrden.detalle.forEach(async (itemdet) => {
          const menuH = await utilGetCollectionFilterReference(
            "menu",
            "registro",
            "==",
            localOrden.puesto,
            "registro",
          );
          if (itemdet?.id && itemdet?.selectedDate && itemdet?.selectedTime) {
            const documplat = doc(
              projectFirestore,
              "menu",
              menuH[0].id,
              "platillo",
              itemdet.id,
            );
            if (itemdet?.selectedDate && itemdet?.selectedTime) {
              const dataplat = (await getDoc(documplat)).data();
              let dispo2 = { ...dataplat?.reservados };
              if (
                dispo2 &&
                dispo2[itemdet?.selectedDate] &&
                dispo2[itemdet?.selectedDate][itemdet?.selectedTime]
              ) {
                dispo2[itemdet?.selectedDate][itemdet?.selectedTime] =
                  dispo2[itemdet?.selectedDate][itemdet?.selectedTime] -
                  itemdet?.cantidad;
                updateDoc(documplat, { reservados: dispo2 });
              }
            } else {
              const dataplat = (await getDoc(documplat)).data();
              let dispo2 = { ...dataplat?.reservados };
              if (
                dispo2 &&
                dispo2[itemdet?.selectedDate] &&
                dispo2[itemdet?.selectedDate][itemdet?.selectedDate]
              ) {
                dispo2[itemdet?.selectedDate][itemdet?.selectedDate] =
                  dispo2[itemdet?.selectedDate][itemdet?.selectedDate] -
                  itemdet?.cantidad;
                updateDoc(documplat, { reservados: dispo2 });
              }
            }
          }
        });
      }
      OTmp.status = status;
      let puntosModificar = puntosUser;
      if (parseFloat(localOrden.puntosusados) > 0 && idPuntos) {
        addDoc(collection(projectFirestore, "puntos", idPuntos, "historial"), {
          descripcion: "Se regresaron " + localOrden.puntosusados + " puntos",
          fecha: new Date(),
          folioOrden: localOrden.folio ? localOrden.folio : "0",
        });
        setDoc(doc(projectFirestore, "puntos", idPuntos), {
          id_usuario: localOrden.user,
          id_local: localOrden.puesto,
          puntos: puntosUser + parseFloat(localOrden.puntosusados),
        });
        puntosModificar = puntosUser + parseFloat(localOrden.puntosusados);
      }
      if (
        parseFloat(localOrden.puntosgenerados) > 0 &&
        idPuntos &&
        localOrden.reclamados
      ) {
        OTmp.reclamados = false;
        addDoc(collection(projectFirestore, "puntos", idPuntos, "historial"), {
          descripcion:
            "Se cancelaron " + localOrden.puntosgenerados + " puntos",
          fecha: new Date(),
          folioOrden: localOrden.folio ? localOrden.folio : "0",
        });
        setDoc(doc(projectFirestore, "puntos", idPuntos), {
          id_usuario: localOrden.user,
          id_local: localOrden.puesto,
          puntos: puntosModificar - parseFloat(localOrden.puntosgenerados),
        });
      }
      await utilUpdateDocument("turnero", OTmp.id, OTmp);
      await addNotifyOrden(notificacion);
      setLocalOrden(OTmp);
      handleClose();
    }
  };

  function CustomToggle({ text, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      console.log("totally custom!"),
    );

    return (
      <h6
        onClick={decoratedOnClick}
        style={{ fontSize: 14, fontWeight: "bold" }}
      >
        {text}
      </h6>
    );
  }

  useEffect(() => {
    function fetchData() {
      let p = query(collection(projectFirestore, "puntos"));
      p = query(
        p,
        where("id_usuario", "==", localOrden.user),
        where("id_local", "==", localOrden.puesto),
      );
      const querySnapshot = getDocs(p);
      querySnapshot.then((doc) => {
        let p = 0;
        if (doc.empty) {
          if (p === 0) {
            addDoc(collection(projectFirestore, "puntos"), {
              id_usuario: localOrden.user,
              id_local: localOrden.puesto,
              puntos: 0,
            });
            p++;
          }
        }
      });
      onSnapshot(p, async (docd) => {
        docd.docs.forEach((element) => {
          if (element.exists()) {
            setIdPuntos(element.id);
            let datap = element.data();
            setPuntosUser(datap.puntos);
          }
        });
      });
      if (localOrden.status === "PENDIENTE" && pagar) {
        setCobroExtra(true);
      }
    }
    setTotalPages(Math.ceil(items.length / itemsPerPage));
    let nump = [];
    for (let i = 1; i <= totalPages; i++) {
      nump.push(i);
    }
    if (totalPages && localOrden.user) {
      fetchData();
    }
  }, [
    indexOfFirstItem,
    indexOfLastItem,
    items,
    itemsPerPage,
    totalPages,
    localOrden,
    orden,
    pagar,
  ]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        style={ticket && { opacity: 0 }}
        fullscreen
        size="lg"
      >
        <Row style={{ marginTop: "10px" }}>
          <Col md={4}>
            <Button
              onClick={(e) => {
                e.preventDefault();
                handleClose();
              }}
              variant="ds"
              id="volver"
              className="newbutton-style nonfilledtext-color"
            >
              {"< "}
              Volver a ordenes
            </Button>
          </Col>
          <Col md={4}>
            <h1
              style={{
                color: "#FA5227",
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              ORDEN {localOrden.status}
            </h1>
          </Col>
          <Col md={4} style={{ textAlign: "right" }}>
            {orden.status !== "CANCELADO" && (
              <Button
                onClick={marcaOrdenCancelada}
                variant="ds"
                id="cancelar"
                className="newbutton-style nonfilledtext-color"
              >
                <i
                  className="bx bx-trash icon"
                  style={{ fontSize: "22px" }}
                ></i>
                Cancelar orden
              </Button>
            )}
          </Col>
        </Row>
        <Row style={{ marginTop: 15 }}>
          <Col md={2}>
            <h1
              className={
                "text-center-nombre card-header-list color-" + orden.status
              }
              style={{ fontSize: 60 }}
            >
              #{orden.number}
            </h1>
          </Col>
          <Col style={{ textAlign: "left" }} xs={6}>
            {orden.table ? <h4>{"Mesa " + orden.table}</h4> : ""}
            <h4 style={{ fontWeight: "700" }}>{orden.user_name}</h4>
            <h6>
              {formatTimestamp(orden.fecha).date}{" "}
              {formatTimestamp(orden.fecha).time}
            </h6>
            <h6>{orden.ordenadoPor}</h6>
          </Col>
          <Col md={2}>
            <Row>
              <Col md={3}>
                <h1
                  style={{
                    color: "#FA5227",
                  }}
                >
                  <FontAwesomeIcon icon={faBagShopping} />
                </h1>
              </Col>
              <Col md={9}>
                <h2>{orden.detalle.length}</h2>
                <h6>Productos</h6>
              </Col>
            </Row>
          </Col>
          <Col md={2}>
            <h2
              style={{
                color: "#08832c",
              }}
            >
              ${parseFloat(orden.total).toFixed(2)}
            </h2>
            <h6
              style={{
                color: "#08832c",
              }}
            >
              Total de la orden
            </h6>
          </Col>
        </Row>
        <Modal.Body>
          <h4>Productos del pedido</h4>
          {orden.detalle.map((item, index) => (
            <Row style={{ marginBottom: 10 }}>
              <Col md={1}>
                <h1
                  className={
                    "text-center-nombre card-header-list color-" + orden.status
                  }
                >
                  {index + 1}
                </h1>
                <h6 className={"color-" + item.status}>{item.status}</h6>
              </Col>
              <Col md={1}>
                <label className="marginlbl">
                  <img
                    id="logo_img"
                    src={item.img}
                    height="160px"
                    width="150px"
                    style={{ borderRadius: 10 }}
                    alt=""
                  />
                </label>
              </Col>
              <Col md={1}>
                <h2 className={"text-center-nombre card-header-list"}>
                  {item.cantidad}
                  <h6 className={"text-center-nombre card-header-list"}>pza</h6>
                </h2>
              </Col>
              <Col md={3}>
                <h3 style={{ fontWeight: "600" }}>{item.name}</h3>
                <h6 style={{ fontSize: 14, fontWeight: "bold" }}>
                  {item.description}
                </h6>
                {item.note !== "" && (
                  <Accordion defaultActiveKey={index}>
                    <CustomToggle eventKey={index} text={"Nota:"} />
                    <Accordion.Collapse eventKey={index}>
                      <h6>{item.note}</h6>
                    </Accordion.Collapse>
                  </Accordion>
                )}
              </Col>
              <Col md={2}>
                <h5>
                  Ingredientes
                  {"(" + Object.keys(item.ingredientes).length + ")"}
                </h5>
                {Object.keys(item.ingredientes).map((element) => {
                  return (
                    <Row>
                      <Col md={6}>
                        {" "}
                        <strong>
                          {"-" +
                            item.ingredientes[element].name +
                            "(" +
                            item.ingredientes[element].cantidad +
                            ")" +
                            "\n "}
                        </strong>
                      </Col>
                      <Col md={6} style={{ textAlign: "right" }}>
                        {" "}
                        <strong>
                          {item.ingredientes[element].costo
                            ? "$" +
                              (
                                parseFloat(item.ingredientes[element].costo) *
                                parseFloat(item.ingredientes[element].cantidad)
                              ).toFixed(2)
                            : "Gratis"}
                        </strong>
                      </Col>
                    </Row>
                  );
                })}{" "}
                <Row style={{ marginTop: 8 }}>
                  <Col md={8}>
                    {" "}
                    <strong>Subtotal:</strong>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    {" "}
                    <strong>
                      $
                      {Object.keys(item.ingredientes)
                        .reduce((acc, elem) => {
                          if (item.ingredientes[elem].costo) {
                            return (
                              acc +
                              parseFloat(item.ingredientes[elem].costo) *
                                parseFloat(item.ingredientes[elem].cantidad)
                            );
                          } else {
                            return acc;
                          }
                        }, 0)
                        .toFixed(2)}
                    </strong>
                  </Col>
                </Row>
              </Col>
              <Col md={2}>
                <h5>Añadidos{"(" + Object.keys(item.anadidos).length + ")"}</h5>
                {Object.keys(item.anadidos).map((element) => {
                  return (
                    <Row>
                      <Col md={6}>
                        {" "}
                        <strong>
                          {"-" +
                            item.anadidos[element].name +
                            "(" +
                            item.anadidos[element].cantidad +
                            ")" +
                            "\n "}
                        </strong>
                      </Col>
                      <Col md={6} style={{ textAlign: "right" }}>
                        {" "}
                        <strong>
                          {item.anadidos[element].precio
                            ? "$" +
                              (
                                parseFloat(item.anadidos[element].precio) *
                                parseFloat(item.anadidos[element].cantidad)
                              ).toFixed(2)
                            : "Gratis"}
                        </strong>
                      </Col>
                    </Row>
                  );
                })}{" "}
                <Row style={{ marginTop: 8 }}>
                  <Col md={8}>
                    {" "}
                    <strong>Subtotal:</strong>
                  </Col>
                  <Col md={4} style={{ textAlign: "right" }}>
                    {" "}
                    <strong>
                      $
                      {Object.keys(item.anadidos)
                        .reduce((acc, elem) => {
                          if (item.anadidos[elem].precio) {
                            return (
                              acc +
                              parseFloat(item.anadidos[elem].precio) *
                                parseFloat(item.anadidos[elem].cantidad)
                            );
                          } else {
                            return acc;
                          }
                        }, 0)
                        .toFixed(2)}
                    </strong>
                  </Col>
                </Row>
              </Col>
              <Col md={2}>
                <Row
                  style={{
                    justifyContent: "space-evenly",
                    marginLeft: 10,
                    marginRight: 10,
                  }}
                >
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    variant="ds"
                    className="newbutton-style nonfilledtext-color"
                  >
                    <i
                      className="bx bx-chevron-up icon"
                      style={{ fontSize: "22px" }}
                    ></i>
                  </Button>
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    variant="ds"
                    id="cancelar"
                    className="newbutton-style nonfilledtext-color"
                  >
                    <i
                      className="bx bx-trash icon"
                      style={{ fontSize: "22px" }}
                    ></i>
                  </Button>
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    variant="ds"
                    className="newbutton-style nonfilledtext-color"
                  >
                    <i
                      className="bx bx-note icon"
                      style={{ fontSize: "22px" }}
                    ></i>
                  </Button>
                </Row>
                <Row style={{ textAlign: "center", marginTop: 20 }}>
                  {" "}
                  <h3
                    style={{
                      color: "#08832c",
                    }}
                  >
                    $
                    {(
                      parseFloat(item.costo) * parseFloat(item.cantidad)
                    ).toFixed(2)}
                  </h3>
                  <br />
                  <h6
                    style={{
                      color: "#1C2D77",
                    }}
                  >
                    + $
                    {Object.keys(item.ingredientes)
                      .reduce((acc, elem) => {
                        if (item.ingredientes[elem].costo) {
                          return (
                            acc +
                            parseFloat(item.ingredientes[elem].costo) *
                              parseFloat(item.ingredientes[elem].cantidad)
                          );
                        } else {
                          return acc;
                        }
                      }, 0)
                      .toFixed(2)}{" "}
                    en ingredientes
                  </h6>
                  <h6
                    style={{
                      color: "#1C2D77",
                    }}
                  >
                    + $
                    {Object.keys(item.anadidos)
                      .reduce((acc, elem) => {
                        if (item.anadidos[elem].precio) {
                          return (
                            acc +
                            parseFloat(item.anadidos[elem].precio) *
                              parseFloat(item.anadidos[elem].cantidad) *
                              parseFloat(item.cantidad)
                          );
                        } else {
                          return acc;
                        }
                      }, 0)
                      .toFixed(2)}{" "}
                    en añadidos
                  </h6>
                </Row>
                <Row></Row>
              </Col>
            </Row>
          ))}
        </Modal.Body>
        <Modal.Footer className="footers">
          <Row style={{ marginLeft: 20, marginRight: 20 }}>
            <Col
              md={6}
              style={{
                textAlign: "left",
                color: "#1C2D77",
              }}
            >
              <strong>Subtotal (Productos)</strong>
            </Col>
            <Col
              md={6}
              style={{
                textAlign: "right",
                color: "#1C2D77",
              }}
            >
              <strong>
                ${" "}
                {(
                  orden.detalle.reduce((acc, item) => {
                    const tot =
                      parseFloat(item.costo) * parseFloat(item.cantidad);
                    return acc + tot;
                  }, 0) - parseFloat(orden.cobroiva)
                ).toFixed(2)}{" "}
              </strong>
            </Col>
            {orden.detalle.reduce((acc, item) => {
              const tot = Object.keys(item.anadidos).reduce((acc, elem) => {
                if (item.anadidos[elem].precio) {
                  return (
                    acc +
                    parseFloat(item.anadidos[elem].precio) *
                      parseFloat(item.anadidos[elem].cantidad)
                  );
                } else {
                  return acc;
                }
              }, 0);
              return acc + tot;
            }, 0) > 0 && (
              <>
                <Col
                  md={6}
                  style={{
                    textAlign: "left",
                    color: "#1C2D77",
                  }}
                >
                  <strong>Subtotal (Añadidos)</strong>
                </Col>
                <Col
                  md={6}
                  style={{
                    textAlign: "right",
                    color: "#1C2D77",
                  }}
                >
                  <strong>
                    ${" "}
                    {orden.detalle
                      .reduce((acc, item) => {
                        const tot = Object.keys(item.anadidos).reduce(
                          (acc, elem) => {
                            if (item.anadidos[elem].precio) {
                              return (
                                acc +
                                parseFloat(item.anadidos[elem].precio) *
                                  parseFloat(item.anadidos[elem].cantidad)
                              );
                            } else {
                              return acc;
                            }
                          },
                          0,
                        );
                        return acc + tot;
                      }, 0)
                      .toFixed(2)}
                  </strong>
                </Col>
              </>
            )}
            {orden.detalle.reduce((acc, item) => {
              const tot = Object.keys(item.ingredientes).reduce((acc, elem) => {
                if (item.ingredientes[elem].costo) {
                  return (
                    acc +
                    parseFloat(item.ingredientes[elem].costo) *
                      parseFloat(item.ingredientes[elem].cantidad)
                  );
                } else {
                  return acc;
                }
              }, 0);
              return acc + tot;
            }, 0) > 0 && (
              <>
                <Col
                  md={6}
                  style={{
                    textAlign: "left",
                    color: "#1C2D77",
                  }}
                >
                  <strong>Subtotal (Ingredientes)</strong>
                </Col>
                <Col
                  md={6}
                  style={{
                    textAlign: "right",
                    color: "#1C2D77",
                  }}
                >
                  <strong>
                    ${" "}
                    {orden.detalle
                      .reduce((acc, item) => {
                        const tot = Object.keys(item.ingredientes).reduce(
                          (acc, elem) => {
                            if (item.ingredientes[elem].costo) {
                              return (
                                acc +
                                parseFloat(item.ingredientes[elem].costo) *
                                  parseFloat(item.ingredientes[elem].cantidad)
                              );
                            } else {
                              return acc;
                            }
                          },
                          0,
                        );
                        return acc + tot;
                      }, 0)
                      .toFixed(2)}
                  </strong>
                </Col>
              </>
            )}
            <Col
              md={6}
              style={{
                textAlign: "left",
                color: "#1C2D77",
              }}
            >
              <strong>IVA ({orden.iva}%)</strong>
            </Col>
            <Col
              md={6}
              style={{
                textAlign: "right",
                color: "#1C2D77",
              }}
            >
              <strong>$ {parseFloat(orden.cobroiva).toFixed(2)} </strong>
            </Col>
            <Col
              md={6}
              style={{
                textAlign: "left",
              }}
            >
              <h3
                style={{
                  fontWeight: "bold",
                }}
              >
                Total
              </h3>
            </Col>
            <Col
              md={6}
              style={{
                textAlign: "right",
              }}
            >
              <h3
                style={{
                  color: "#08832c",
                }}
              >
                $ {parseFloat(orden.total).toFixed(2)}
              </h3>
            </Col>
          </Row>
          <Row style={{ marginBottom: 7, justifyContent: "center" }}>
            {/* {localOrden.status === "PENDIENTE" ? (
              <Col md={3} style={{ textAlign: "center" }}>
                <Button
                  variant="ds"
                  className="newbutton-style filled fill"
                  id="efectivo"
                >
                  <FontAwesomeIcon icon={faMoneyBill} /> Cobrar
                </Button>
              </Col>
            ) : (
              <></>
            )} */}
            {localOrden.status === "ATENDIDO" ||
            localOrden.status === "ENTREGAR" ||
            localOrden.status === "COMPLETADO" ? (
              <>
                {employee && employee.barra ? (
                  <></>
                ) : (
                  <>
                    <Col md={3} style={{ textAlign: "center" }}>
                      <Button
                        variant="ds"
                        className="newbutton-style filled fill"
                        id="ticket"
                        onClick={() => setTicket(true)}
                      >
                        <FontAwesomeIcon icon={faList} /> Ticket
                      </Button>
                    </Col>
                    <Col md={3} style={{ textAlign: "center" }}>
                      <Button
                        variant="ds"
                        className="newbutton-style filled fill"
                        id="wa"
                        onClick={marcaOrdenPendiente}
                      >
                        <FontAwesomeIcon icon={faRepeat} /> Regresar a
                        pendientes
                      </Button>
                    </Col>
                  </>
                )}
              </>
            ) : (
              <></>
            )}
            {localOrden.status === "ATENDIDO" ? (
              <>
                <Col md={3} style={{ textAlign: "center" }}>
                  <Button
                    variant="ds"
                    className="newbutton-style filled fill"
                    id="efectivo"
                    onClick={marcaOrdenEntregar}
                  >
                    <FontAwesomeIcon icon={faCheck} /> Entregar orden
                  </Button>
                </Col>
                {localOrden.table ? (
                  <Col md={3} style={{ textAlign: "center" }}>
                    <Button
                      variant="ds"
                      className="newbutton-style filled fill"
                      id="efectivo"
                      onClick={marcaOrdenEntregarMesa}
                    >
                      <FontAwesomeIcon icon={faCheck} /> Entregar orden a mesa
                    </Button>
                  </Col>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
            {localOrden.status === "ENTREGAR" ? (
              <>
                <Col md={3} style={{ textAlign: "center" }}>
                  <Button
                    variant="ds"
                    className="newbutton-style filled fill"
                    id="efectivo"
                    onClick={marcaOrdenCompleta}
                  >
                    <FontAwesomeIcon icon={faCheck} /> Marcar como orden
                    completa
                  </Button>
                </Col>
              </>
            ) : (
              <></>
            )}
          </Row>
        </Modal.Footer>
      </Modal>
      <IngresoManual
        show={edicion}
        handleClose={handleCloseEdicion}
        orden={localOrden}
      ></IngresoManual>
      <Modal show={cobroExtra} onHide={() => setCobroExtra(false)}>
        <ModalHeader>Cobro extra</ModalHeader>
        <ModalBody>
          <Form.Group controlId="type">
            <label className="center"> Metodo de pago:</label>
            <select
              value={metodoPago}
              onChange={(e) => {
                ChangeMetPag(e);
              }}
            >
              <option value={"Tarjeta"}>Tarjeta</option>
              <option value={"Efectivo"}>Efectivo</option>
            </select>
          </Form.Group>
          <div id="divEfect" hidden>
            <Form.Group controlId="formName">
              <Form.Label>Se cobro</Form.Label>
              <Form.Control
                type="number"
                placeholder="0.00"
                pattern="[0-9]{0,13}"
                min={0}
                onChange={(e) => handleEfectivo(e.target.value)}
              />
            </Form.Group>
            <label>
              {cambio < 0 ? "Faltan :" : "Cambio: "} {cambio} $
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={() => setCobroExtra(false)}>
            Regresar
          </Button>
          <Button variant="primary" onClick={() => handleCloseCobroExtra()}>
            Cobrar
          </Button>
          <Button variant="primary" onClick={() => handleCloseCobroExtra(true)}>
            Cobrar e imprimir
          </Button>
        </ModalFooter>
      </Modal>
      <Ticket
        orden={localOrden}
        registro={register}
        impresion={impresion}
        show={ticket}
        handleClose={() => {
          setTicket(false);
        }}
        setImpresion={setImpresion}
      />
    </>
  );
};
export default ViewPedidoNew;
